import { render, staticRenderFns } from "./ModalImportTabsCanva.vue?vue&type=template&id=27886af6"
import script from "./ModalImportTabsCanva.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalImportTabsCanva.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports